// =============================================================================
// src/data/analytics-graphql-roots.ts — Root fields do source Hasura
// `social_listening` (prefixo sl_, contrato completo com o backend AtalaIA em
// hasura/apply_social_listening_permissions.py). Extraído de
// analytics-live-query.ts em 2026-07-28 (o arquivo encostava no limite de 500
// linhas) — troca de naming continua em 1 lugar só; a query re-exporta.
// =============================================================================

/** Root fields do source social_listening no Hasura (contrato completo). */
export const ANALYTICS_GRAPHQL_ROOTS = {
  mentionsDaily: 'sl_serving_v_mentions_daily',
  // 025 (2026-09-02): grão dia × plataforma × kind × is_nucleo × is_vip ×
  // is_substantivo — KPIs/manchete por escopo (Nucleo · Omar · Contexto).
  mentionsDailyScoped: 'sl_serving_v_mentions_daily_scoped',
  // 025: última coleta/publicação por plataforma — eyebrow "atualizado há X".
  ingestionFreshness: 'sl_serving_v_ingestion_freshness',
  mentionsFeed: 'sl_serving_v_mentions_feed',
  // 031 (2026-09-20): chaves do feed, SEM texto. Existe por um motivo so — a
  // permissao anon da mentionsFeed tem limit 5000 e o Hasura aplica o limite da
  // permissao DENTRO da subquery da agregacao, entao contar por la responderia
  // "5000" num recorte de 42.425 e a paginacao mentiria o numero de paginas.
  // Esta view tem allow_aggregations e NAO tem limit.
  mentionsFeedKeys: 'sl_serving_v_mentions_feed_keys',
  mentionsFeedKeysAggregate: 'sl_serving_v_mentions_feed_keys_aggregate',
  // Agregado por autor NO SQL (migration 012): o grão diário passava de 5.000
  // linhas em 30d e o limit da permissão truncava a agregação client-side.
  authorWindow: 'sl_serving_v_author_window_30d',
  newsSourceDaily: 'sl_serving_v_news_source_daily',
  // Expostos no Hasura porém SEM superfície consumidora no Analytics nesta fase:
  authorDaily: 'sl_serving_v_author_daily',
  watchTimeline: 'sl_serving_v_watch_timeline',
  regionDaily: 'sl_serving_v_region_daily',
  mentionsTimeline: 'sl_serving_v_mentions_timeline',
  topPosts: 'sl_serving_v_top_posts_by_engagement',
  topComments: 'sl_serving_v_top_comments_mentioning_actor',
  followerDelta: 'sl_serving_v_follower_delta_daily',
  emergingTerms: 'sl_serving_v_emerging_terms',
  // 015: menções reais por ator×plataforma (30d) — chips de Personagens.
  actorPlatformWindow: 'sl_serving_v_actor_platform_window_30d',
  // 021: janelas agregadas NO SQL p/ a aba Análises (rollups de tema/ator seguem
  // defasados no backend — pendência de ops; estas leem core.* direto).
  watchWindow: 'sl_serving_v_watch_window_30d',
  regionWindow: 'sl_serving_v_region_window_30d',
  // 021: espelho da configuração REAL de ingestão (aba Configurações): perfis c/
  // cadência da fila-mestra, recorrências por tipo de alvo, léxico do filtro de
  // relevância e escopo editorial de veículos. Somente-leitura.
  watchQueryConfig: 'sl_config_watch_query',
  ingestionProfile: 'sl_serving_v_ingestion_profile',
  ingestionCadence: 'sl_serving_v_ingestion_cadence',
  ingestionScopeTerm: 'sl_serving_v_ingestion_scope_term',
  ingestionOutletScope: 'sl_serving_v_ingestion_outlet_scope',
  authorBlocklist: 'sl_config_author_blocklist',
  // 022: edicoes diarias dos Cards Taticos como DOCUMENTO markdown (o host
  // publica o .md inteiro; a aba Resumo de IA parseia e navega entre dias).
  cardEdition: 'sl_serving_v_card_edition',
  // Curadoria (013): INSERT anon na blocklist de autores; client_id vem da
  // session var do Hasura (preset), nunca do payload.
  insertAuthorBlock: 'sl_insert_config_author_blocklist_one',
  insertScopeOverride: 'sl_insert_config_content_relevance_override_one',
} as const;
